export var CalibrationTypes;
(function (CalibrationTypes) {
    CalibrationTypes["NOT_APPLICABLE"] = "";
    CalibrationTypes["ERMF"] = "ERMF";
    CalibrationTypes["USER"] = "User";
    CalibrationTypes["PROJECTION"] = "Proj";
    CalibrationTypes["REGION"] = "Region";
    CalibrationTypes["ERROR"] = "Error";
    CalibrationTypes["UNCALIBRATED"] = "Uncalibrated";
    CalibrationTypes["CALIBRATED"] = "Calibrated";
    CalibrationTypes["UNKNOWN"] = "Unknown";
})(CalibrationTypes || (CalibrationTypes = {}));
export default CalibrationTypes;
